import { t } from '@if/core/i18n'
import { formatDate, formatNumber } from '@if/core/utils'
import { Grid, InputAdornment, TextField, Typography } from '@mui/material'
import { ApplicableMerchantPaymentPlan } from '@src/data/types/ApplicableMerchantPaymentPlan'

interface Props {
  selectedPlan: ApplicableMerchantPaymentPlan
}

const SelectedPromoPlanDisplay = ({ selectedPlan }: Props) => {
  return (
    <>
      <Typography style={{ marginBottom: '1rem' }}>{t('merchant.promo.detail')}</Typography>
      <Grid container columns={12} spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            label={t('merchant.promo.interestRate')}
            value={formatNumber(selectedPlan.interestRate)}
            fullWidth
            disabled
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              },
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            label={t('merchant.promo.reducedInterestRate')}
            value={formatNumber(selectedPlan.reducedInterestRate)}
            fullWidth
            disabled
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              },
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            label={t('merchant.promo.loanTerm')}
            value={formatNumber(selectedPlan.loanTerm)}
            fullWidth
            disabled
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">{t('common.months')}</InputAdornment>,
              },
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            label={t('merchant.promo.reducedRateDuration')}
            value={formatNumber(selectedPlan.reducedRateDurationInMonths)}
            fullWidth
            disabled
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">{t('common.months')}</InputAdornment>,
              },
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            label={t('merchant.ratesAndFees.adminFeeCustomer')}
            value={selectedPlan.borrowerFeeRate}
            fullWidth
            disabled
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              },
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            label={t('merchant.ratesAndFees.adminFeeMerchant')}
            value={selectedPlan.merchantFeeRate}
            fullWidth
            disabled
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              },
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            label={t('merchant.promo.activeFrom')}
            value={formatDate(selectedPlan.activeFrom)}
            fullWidth
            disabled
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            label={selectedPlan.expiresOn ? t('merchant.promo.expiresOn') : t('merchant.promo.noExpiresOn')}
            value={formatDate(selectedPlan.expiresOn)}
            fullWidth
            disabled
          />
        </Grid>
      </Grid>
    </>
  )
}

export default SelectedPromoPlanDisplay
